const TOOL_USAGE_KEY = '3toolspro_tool_usage_v1';

const safeReadUsage = () => {
  try {
    const raw = localStorage.getItem(TOOL_USAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
};

const safeWriteUsage = (value) => {
  try {
    localStorage.setItem(TOOL_USAGE_KEY, JSON.stringify(value));
  } catch {
    // ignore storage failures
  }
};

export const trackToolUsage = (toolId) => {
  if (!toolId || typeof window === 'undefined') return;
  const usage = safeReadUsage();
  usage[toolId] = Number(usage[toolId] || 0) + 1;
  safeWriteUsage(usage);
};

export const getToolUsageMap = () => {
  if (typeof window === 'undefined') return {};
  return safeReadUsage();
};

export const sortToolsByUsage = (tools, customOrder = []) => {
  const usage = getToolUsageMap();
  const customOrderMap = new Map(customOrder.map((id, index) => [id, index]));

  return [...tools].sort((a, b) => {
    const aCustom = customOrderMap.has(a.id) ? customOrderMap.get(a.id) : Number.MAX_SAFE_INTEGER;
    const bCustom = customOrderMap.has(b.id) ? customOrderMap.get(b.id) : Number.MAX_SAFE_INTEGER;
    if (aCustom !== bCustom) return aCustom - bCustom;

    const aUsage = Number(usage[a.id] || 0);
    const bUsage = Number(usage[b.id] || 0);
    if (aUsage !== bUsage) return bUsage - aUsage;

    return a.name.localeCompare(b.name);
  });
};
